import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { AppShell, Sidebar, TopBar } from '@suvoda-uat/ui-suvoda';
import { AuthoringQueueView } from '../components/AuthoringQueueView.js';
import { currentUserName, signOut } from '../lib/auth.js';
import { navTargetFor, visibleNavItems } from '../lib/nav.js';

/**
 * F-017 (US2) — the Authoring Queue destination: the honestly-labelled home
 * for study-specific scope. Reads `trialId` from search (the assembly carries
 * it) and renders the queue inside the app shell. Thin glue — the view owns the
 * queue + transitions; the route owns navigation + the trial context.
 */
export const Route = createFileRoute('/authoring-queue')({
  validateSearch: (search: Record<string, unknown>): { trialId: string } => ({
    trialId: typeof search['trialId'] === 'string' ? search['trialId'] : '',
  }),
  component: AuthoringQueueRoute,
});

function AuthoringQueueRoute() {
  const { trialId } = Route.useSearch();
  const navigate = useNavigate();

  return (
    <AppShell
      sidebar={
        <Sidebar
          items={visibleNavItems()}
          activeId="uat"
          searchPlaceholder="What are you looking for?"
          onNavigate={(id) => {
            if (id === 'uat') {
              void navigate({ to: '/uat', search: { trialId } });
              return;
            }
            const to = navTargetFor(id);
            if (to !== undefined) void navigate({ to });
          }}
          onSignOut={() => signOut()}
        />
      }
      topbar={
        <TopBar label="AUTHORING QUEUE" userName={currentUserName()} onSignOut={() => signOut()} />
      }
    >
      <AuthoringQueueView trialId={trialId} />
    </AppShell>
  );
}
